import React, {useCallback} from "react";
import styles from "./TextInput.module.scss";
import classNames from "classnames";

function TextInput(props) {
    const {
        id,
        name = "",
        onBlur,
        value,
        setValue,
        label,
        placeholder,
        type="text",
        required = false,
        disabled = false,
        iconSrc,
        overrideContainerClassName,
    } = props;


    const handleChange = useCallback((event) => {
        if (setValue) {
            setValue(event.target.value);
        }
    }, []);

    const _onBlur = () => {
        if (onBlur) {
            onBlur();
        }
    }

    const renderLabel = () => {
        if (label) {
            const classname = classNames(styles.label, {
                [styles.labelWithPicture]: iconSrc,
                [styles.labelDisabled]: disabled,
            });
            return (
                <>
                    {iconSrc && <img className={styles.inputPicture} src={iconSrc}/>}
                    <label htmlFor={id} className={classname}>
                        {label}
                    </label>
                </>
            )
        }

        return;
    }

    return (
        <div className={classNames(styles.inputContainer, overrideContainerClassName)}>
            <input id={id}
                   className={styles.input}
                value={value}
                name={name}
                required={required}
                autoComplete="off"
                onChange={handleChange}
                placeholder={placeholder}
                type={type}
                onBlur={_onBlur}
                disabled={disabled} />
            {renderLabel()}
        </div>
    );
}

export default TextInput;
